import useTitle from "../../../hooks/useTitle"
import {  useNavigate, useParams } from "react-router-dom"
import { useState } from "react"
import { useGetFinalQuestionsQuery } from "../../questionSets/questionSetsApiSlice"
import PulseLoader from "react-spinners/PulseLoader"
import UserQuestionListAdmin from "./UserQuestionListAdmin"
function UserQuestionListFilterAdmin() {
    const {groupId} = useParams()
    useTitle('geshtop-Exercise: QuestionSets List')
    const [q,setQ] = useState('')
    const [finalQuestionId,setFinalQuestionId] = useState('')

  const { data: finalQuestions } = useGetFinalQuestionsQuery({questionSetId:"0"})

    const navigate = useNavigate()

   if(groupId==="0"){
    return <h1>Please select group</h1>
   }
if(!finalQuestions || !finalQuestions.length){
  return <PulseLoader color={"#FFF"} />
}


const filteredFinalQuestions  = finalQuestions.filter(x=>x.group?._id === groupId)
const options = filteredFinalQuestions?.map(final => {
  return (
      <option
          key={final._id}
          value={final._id}
      >{final.title} </option >
  )
})
    const content =(<>
    <div className="filter-form">
  
                  
        <div className="filter-form-item">
            <input className="form__input" onChange={(e)=>setQ(e.target.value)} />
            <select
                    id="finalQuestion"
                    name="finalQuestion"
                    className={`form__select `}
                    value={finalQuestionId}
                    onChange={(e)=>setFinalQuestionId(e.target.value)}
                >
                  <option></option>
                   {options}
                </select>
            </div>
    </div>
 { <UserQuestionListAdmin  q={q}   finalQuestionId={finalQuestionId}  /> }
</> ) 
  return content;
}

export default UserQuestionListFilterAdmin